import { render, staticRenderFns } from "./ClientManager.vue?vue&type=template&id=a0553506&"
import script from "./ClientManager.vue?vue&type=script&lang=js&"
export * from "./ClientManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports